import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../assets/images/logoo.svg";
import CreateAccountModal from "../Modals/CreateModal"
import SignInModal from "../Modals/signInModal";               // adjust path

const navItems = [
  { label: "Home", path: "/" },
  { label: "How it Works", path: "/how-it-works" },
  { label: "Solutions", path: "/solutions" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null); // null | 'signup' | 'signin'

  return (
    <>
      <header className="bg-white relative z-50">
        <div className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">

          {/* Logo */}
          <div className="flex items-center gap-3">
            <img src={Logo} alt="Invexflow" className="w-12 h-8 rounded-md" />
            <span className="font-semibold text-[#0F172A]">Invexflow</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-md transition ${
                    isActive
                      ? "bg-[#D7F3EF] text-[#0F766E]"
                      : "text-[#475569] hover:text-[#0F172A]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-4">
            <div className="flex items-center gap-2 border border-[#E2E8F0] rounded-md px-2 py-1 text-xs">
              <span className="font-semibold text-[#0F172A]">EN</span>
              <span className="text-[#94A3B8]">DE</span>
            </div>

            {/* ✅ Changed from Link to button — opens modal */}
            <button
              onClick={() => setActiveModal("signup")}
              className="bg-[#00B3A4] text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-[#009688] transition"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden text-[#0F172A]"
            aria-label="Toggle menu"
          >
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-white border-t border-[#E2E8F0] shadow-sm">
            <div className="px-6 py-6 flex flex-col gap-4 text-sm font-medium">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    isActive ? "text-[#0F766E] font-semibold" : "text-[#475569]"
                  }
                >
                  {item.label}
                </NavLink>
              ))}

              <div className="flex gap-3 pt-4 border-t border-[#E2E8F0] text-xs">
                <span className="font-semibold text-[#0F172A]">EN</span>
                <span className="text-[#94A3B8]">DE</span>
              </div>

              {/* ✅ Changed from Link to button — opens modal + closes mobile menu */}
              <button
                onClick={() => {
                  setActiveModal("signup");
                  setMobileOpen(false);
                }}
                className="mt-4 bg-[#00B3A4] text-white text-center font-semibold py-3 rounded-md"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Divider */}
      <div className="h-[2px] bg-[#00B3A4]" />

      {/* ✅ Modals — rendered outside header so z-index stacking is clean */}
      {activeModal === "signup" && (
        <CreateAccountModal
          onClose={() => setActiveModal(null)}
          onSwitchToSignIn={() => setActiveModal("signin")}
        />
      )}

      {activeModal === "signin" && (
        <SignInModal
          onClose={() => setActiveModal(null)}
          onSwitchToSignUp={() => setActiveModal("signup")}
        />
      )}
    </>
  );
};

export default Header;